// FilterBoxMobile.js
import {
    defineComponent,
    ref,
    computed,
    watch,
    inject
} from "/Scripts/vue.esm-browser.js";
const html = String.raw;
export default defineComponent({
    name: "FilterBoxMobile",
    emits: [],
    setup(props, { emit }) {
        const mobileFilterPopup = inject("mobileFilterPopup", ref(false));
        const filterCount = inject("filterCount");
        return { mobileFilterPopup, filterCount };
    },
    template: html`
        <div class="filter_btn-m_box">
            <button class="filter_btn-m" @click="mobileFilterPopup=true">
                <div>
                    <svg
                        width="23"
                        height="24"
                        viewBox="0 0 23 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M21.68 19.0518H17.7805C17.5634 17.3142 16.0781 15.9658 14.2829 15.9658C12.4876 15.9658 11.0023 17.3142 10.7852 19.0518H0.440014C0.19654 19.0518 0 19.2483 0 19.4918C0 19.7353 0.19654 19.9318 0.440014 19.9318H10.7852C11.0023 21.6694 12.4876 23.0178 14.2829 23.0178C16.0781 23.0178 17.5634 21.6694 17.7805 19.9318H21.68C21.9235 19.9318 22.12 19.7353 22.12 19.4918C22.12 19.2483 21.9235 19.0518 21.68 19.0518ZM14.2829 22.1378C12.9736 22.1378 11.8843 21.1824 11.6741 19.9318C11.6496 19.7891 11.6369 19.6414 11.6369 19.4918C11.6369 19.3422 11.6496 19.1945 11.6741 19.0518C11.8843 17.8012 12.9736 16.8458 14.2829 16.8458C15.5921 16.8458 16.6814 17.8012 16.8917 19.0518C16.9161 19.1945 16.9288 19.3422 16.9288 19.4918C16.9288 19.6414 16.9161 19.7891 16.8917 19.9318C16.6814 21.1824 15.5921 22.1378 14.2829 22.1378Z"
                            fill="white"
                        ></path>
                        <path
                            d="M0.440014 3.96599H10.7852C11.0023 5.70356 12.4876 7.05196 14.2829 7.05196C16.0781 7.05196 17.5634 5.70356 17.7805 3.96599H21.68C21.9235 3.96599 22.12 3.76945 22.12 3.52598C22.12 3.28251 21.9235 3.08597 21.68 3.08597H17.7805C17.5634 1.3484 16.0781 0 14.2829 0C12.4876 0 11.0023 1.3484 10.7852 3.08597H0.440014C0.19654 3.08597 0 3.28251 0 3.52598C0 3.76945 0.19654 3.96599 0.440014 3.96599ZM14.2829 0.880028C15.5921 0.880028 16.6814 1.83535 16.8917 3.08597C16.9161 3.22873 16.9288 3.37637 16.9288 3.52598C16.9288 3.67558 16.9161 3.82323 16.8917 3.96599C16.6814 5.21661 15.5921 6.17193 14.2829 6.17193C12.9736 6.17193 11.8843 5.21661 11.6741 3.96599C11.6496 3.82323 11.6369 3.67558 11.6369 3.52598C11.6369 3.37637 11.6496 3.22873 11.6741 3.08597C11.8843 1.83535 12.9736 0.880028 14.2829 0.880028Z"
                            fill="white"
                        ></path>
                        <path
                            d="M21.68 11.1035H9.04571C8.82864 9.36598 7.34335 8.01758 5.54809 8.01758C3.75283 8.01758 2.26754 9.36598 2.05047 11.1035H0.440014C0.19654 11.1035 0 11.3001 0 11.5436C0 11.787 0.19654 11.9836 0.440014 11.9836H2.05047C2.26754 13.7211 3.75283 15.0695 5.54809 15.0695C7.34335 15.0695 8.82864 13.7211 9.04571 11.9836H21.679C21.9225 11.9836 22.119 11.787 22.119 11.5436C22.119 11.3001 21.9225 11.1035 21.679 11.1035H21.68ZM5.54809 14.1895C4.2388 14.1895 3.14952 13.2342 2.93929 11.9836C2.91485 11.8408 2.90214 11.6932 2.90214 11.5436C2.90214 11.394 2.91485 11.2463 2.93929 11.1035C3.14952 9.85293 4.2388 8.89761 5.54809 8.89761C6.85738 8.89761 7.94666 9.85293 8.15688 11.1035C8.18133 11.2463 8.19404 11.394 8.19404 11.5436C8.19404 11.6932 8.18133 11.8408 8.15688 11.9836C7.94666 13.2342 6.85738 14.1895 5.54809 14.1895Z"
                            fill="white"
                        ></path>
                    </svg>
                </div>
                <span class="filter_number">{{ filterCount }}</span>
            </button>
        </div>
    `,
    methods: {},
});
